<template>
  <v-row class="mt-2">
    <v-col cols="12" class="pa-0">
      <v-card flat>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="10" class="py-0">
              <v-row>
                <v-col cols="12">
                  <h1 style="text-align: center;">Új menetlevél</h1>
                </v-col>
                <v-col cols="12"> <hr class="thinLine" /> </v-col>
                <v-col cols="12" md="4" class="py-0">
                  <v-text-field
                    id="menetlevel_datum"
                    v-model="data.datum"
                    label="Dátum"
                    type="date"
                    max="2999-12-31"
                  />
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                  <v-row v-if="data.fajlnev">
                    <v-col cols="12" md="6" class="py-0">
                      <v-text-field
                        id="menetlevel_fajlnev"
                        v-model="data.fajlnev"
                        label="Menetlevél"
                        readonly
                        clearable
                      />
                    </v-col>
                    <v-col cols="12" md="6" class="py-0 mt-3">
                      <v-btn color="warning" :block="true" @click="getSzamla">
                        Menetlevél
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row v-else>
                    <v-col cols="12" md="6" class="py-0">
                      <v-text-field
                        id="menetlevel_fajlnev"
                        v-model="data.fajlnev"
                        label="Menetlevél"
                        disabled
                      />
                    </v-col>
                    <v-col cols="12" md="6" class="py-0">
                      <uploadButton
                        ref="upButton"
                        :type="'fájlt'"
                        @kep="gotKep"
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" md="2" class="py-1 mt-3">
              <v-row>
                <v-col cols="12" class="py-1 d-none d-sm-flex">
                  <v-btn :block="true" color="info" @click="$router.go(-1)">
                    Vissza
                  </v-btn>
                </v-col>
                <v-col cols="12" class="py-1 d-none d-sm-flex">
                  <v-btn :block="true" color="success" @click="handleSubmit">
                    Mentés
                  </v-btn>
                </v-col>
                <v-col cols="12" class="py-1">
                  <v-btn
                    :block="true"
                    color="primary"
                    :to="`/autok/${$route.params.id}`"
                  >
                    Autó Adatlap
                  </v-btn>
                </v-col>
                <v-col cols="12" class="py-1">
                  <v-btn
                    :block="true"
                    color="primary"
                    :to="`/autok/${$route.params.id}/szervizek`"
                  >
                    További Menetlevelek
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
            <v-col class="d-sm-none">
              <v-btn color="info" fab bottom left fixed @click="$router.go(-1)"
                ><v-icon>arrow_left</v-icon></v-btn
              >
              <v-btn
                color="success"
                fab
                bottom
                right
                fixed
                @click="handleSubmit"
                ><v-icon>save</v-icon></v-btn
              >
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    <v-snackbar
      v-model="mentes"
      :timeout="3000"
      :bottom="true"
      :right="true"
      color="success"
    >
      Sikeres mentés!
    </v-snackbar>
    <v-snackbar
      v-model="hiba"
      :timeout="3000"
      :bottom="true"
      :right="true"
      color="error"
    >
      Hiba mentés közben!
    </v-snackbar>
  </v-row>
</template>

<script>
import uploadButton from "@/components/uploadButton.vue";

export default {
  title: "Új Menetlevél",
  components: { uploadButton },
  data() {
    return {
      data: {
        deleted: 0,
        autoid: this.$route.params.id,
        fajlnev: ""
      },
      mentes: false,
      hiba: false,
      kep: {
        name: ""
      }
    };
  },
  methods: {
    gotKep(e) {
      this.kep = e;
    },
    handleSubmit() {
      this.$axios
        .post("autok/createMenetlevel", {
          ...this.data,
          fajlnev: this.data.fajlnev ? this.data.fajlnev : ""
        })
        .then(resp => {
          if (this.kep.name == "") {
            this.mentes = true;
            this.$router.push({
              path:
                "/autok/" +
                this.$route.params.id +
                "/menetlevelek/" +
                resp.data.newid
            });
          } else {
            let formData = new FormData();
            formData.append("file", this.kep);
            formData.append("id", resp.data.newid);
            this.$axios
              .post("autok/upMenetlevel", formData)
              .then(() => {
                this.mentes = true;
                this.$refs.upButton.removeFile();
                this.$router.push({
                  path:
                    "/autok/" +
                    this.$route.params.id +
                    "/menetlevelek/" +
                    resp.data.newid
                });
              })
              .catch(() => {
                this.hiba = true;
              });
          }
        })
        .catch(() => (this.hiba = true));
    }
  }
};
</script>
